import React, { useEffect, useState } from "react";
import { Database } from "lucide-react";
import AuthEventLogs from "../../components/authenticationPolicy/authEventLogs";
import { PageHeader, PageShell } from "../../design-system/tableUi";
import { AN_COLORS } from "../../design-system/tokens";
import SshAccessLog from "./ssh-access-log/SshAccessLog";

// /pam/auth-logs is shared by every MFA mode; render the log that matches the
// mode the sidebar switch is on. The switch writes localStorage.currentMode and
// fires a "storage" event, so the page follows it without a reload.
//
//   mfa_ad, mfa_radius → the auth-event table (/ad/GetAuthLog), limited to
//                        that mode's protocols
//   mfa_apps           → the same table, limited to the identity provider's
//                        sign-ins: oidc, saml, mfa_api
//   mfa_pam            → the SSH access log (/pam/ssh/accessLog)
//   mfa_db             → not built yet
const readMode = () => localStorage.getItem("currentMode") || "mfa_ad";

export default function AuthLogsIndex() {
  const [mode, setMode] = useState(readMode);

  useEffect(() => {
    const onStorage = () => setMode(readMode());
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  if (mode === "mfa_pam" || mode === "pam") return <SshAccessLog />;
  if (mode === "mfa_db" || mode === "mfa_database") {
    return (
      <PageShell>
        <PageHeader eyebrow="Database · Logs" title="Authentication Logs" />
        <div
          style={{
            background: AN_COLORS.surface,
            border: `1px solid ${AN_COLORS.line}`,
            borderRadius: 10,
            padding: 48,
            textAlign: "center",
            color: AN_COLORS.muted,
            fontSize: 14,
          }}
        >
          <Database size={28} style={{ marginBottom: 10 }} />
          <div>Database access logs are coming soon.</div>
        </div>
      </PageShell>
    );
  }
  // key: a mode change starts the table fresh, with that mode's filters.
  const logMode = mode === "mfa_radius" ? "radius" : mode === "mfa_apps" ? "apps" : "ad";
  return <AuthEventLogs key={logMode} mode={logMode} />;
}
